(() => {
  const SELECTORS = {
    form: '#cart',
    note: '[data-cart-note-input]',
    noteWrap: '[data-cart-note-required]',
    noteError: '[data-cart-note-error]',
    noteDetails: '#Details-CartNote',
    checkoutButton: 'button[name="checkout"][form="cart"], button[name="checkout"]',
  };

  const ERROR_TEXT = 'Uzupełnij instrukcję odbioru dla kuriera, aby przejść dalej do kasy.';

  const isBlank = (value) => !value || !value.trim();

  const init = () => {
    const form = document.querySelector(SELECTORS.form);
    const note = document.querySelector(SELECTORS.note);
    const noteWrap = document.querySelector(SELECTORS.noteWrap);
    const noteError = document.querySelector(SELECTORS.noteError);
    const noteDetails = document.querySelector(SELECTORS.noteDetails);

    if (!form || !note || !noteWrap || !noteError) return;
    if (note.dataset.requiredCheckoutBound === 'true') return;
    note.dataset.requiredCheckoutBound = 'true';

    const setInvalidState = (isInvalid) => {
      noteWrap.classList.toggle('is-invalid', isInvalid);
      note.setAttribute('aria-invalid', isInvalid ? 'true' : 'false');
      noteError.classList.toggle('is-visible', isInvalid);
      note.setCustomValidity(isInvalid ? ERROR_TEXT : '');
    };

    const validate = ({ focus = false } = {}) => {
      const invalid = isBlank(note.value);
      setInvalidState(invalid);

      if (invalid) {
        if (noteDetails && !noteDetails.open) noteDetails.open = true;
        if (focus) note.focus();
      }

      return !invalid;
    };

    note.addEventListener('input', () => {
      if (!isBlank(note.value)) setInvalidState(false);
    });

    note.addEventListener('blur', () => {
      if (isBlank(note.value)) setInvalidState(true);
    });

    note.addEventListener('invalid', (event) => {
      event.preventDefault();
      validate({ focus: true });
    });

    form.addEventListener(
      'submit',
      (event) => {
        const submitter = event.submitter;
        if (!submitter || submitter.name !== 'checkout') return;
        if (validate({ focus: true })) return;
        event.preventDefault();
      },
      true
    );

    document.querySelectorAll(SELECTORS.checkoutButton).forEach((button) => {
      button.addEventListener('click', (event) => {
        if (button.form !== form) return;
        if (validate({ focus: true })) return;
        event.preventDefault();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
